import axios from "@/axios/development";

export async function patchKeyfacts(keyFact) {
    return (await axios.patch("/key-facts", keyFact)).data.data;
}

export async function getKeyfacts(case_id) {
    return (await axios.get(`/key-facts/${case_id}`)).data.data;
}
